'use client';

import { Button } from "flowbite-react";
import { signOut } from "next-auth/react";

export default function SignOutButton() {

    return <Button onClick={() => void signOut()}>
        👋 Sign out – see you in a sec!
    </Button>

}
